'use client'
import type { FormControlProps as MuiFormControlProps } from '@mui/material/FormControl'

import MuiFormControl from '@mui/material/FormControl'

import { styled } from '@mui/material/styles'

type FormControlProps = MuiFormControlProps
const FormControl = styled(MuiFormControl)(() => ({
  '&.MuiFormControl-root': {
    display: 'flex',
    width: '100%',
    flexDirection: 'column',
    alignItems: 'stretch',
    alignSelf: 'stretch',
  },
}))

export default FormControl
export type { FormControlProps }
